import { LeftOutline } from 'antd-mobile-icons'
import { useNavigate } from "react-router-dom";
import "./style.less"

const PubHeader = (props) => {
    const { backToHome } = props;
    const navigate = useNavigate();

    function backHandle() {
        if (backToHome) {
            navigate("/home")
            return
        }
        navigate(-1);
    }

    return (
        <div id="common-header">
            <span className="back-icon" onClick={backHandle}>
                <LeftOutline />
            </span>
            <h2>{props.title}</h2>
        </div>
    )
}

export default PubHeader